import React from 'react';
import PropTypes from 'prop-types';
import { SidebarProvider } from '../contexts/SidebarContext.jsx';

/**
 * Wrapper component that provides SidebarContext to the entire app
 * This ensures the sidebar state persists across page navigation
 */
const AppWithSidebar = ({ children }) => {
    return (
        <SidebarProvider>
            {children}
        </SidebarProvider>
    );
};

AppWithSidebar.propTypes = {
    children: PropTypes.node.isRequired
};

export default AppWithSidebar;
